import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../shared/services/api.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { DateService } from '../../../../shared/services/date.service';

export interface OrderSim {
  id: number;
  created_at: string;
  iccid: string;
  lpa: string;
  imsis: string | null;
  matching_id: string;
  qrcode: string;
  qrcode_url: string;
  airalo_code: string | null;
  apn_type: string;
  apn_value: string | null;
  is_roaming: boolean;
  confirmation_code: string | null;
}

export interface OrderUser {
  id: number;
  created_at: string;
  name: string;
  email: string;
  mobile: string | null;
  address: string | null;
  state: string | null;
  city: string | null;
  postal_code: string | null;
  country_id: string | null;
  company: string;
}

export interface OrderStatus {
  name: string;
  slug: string;
}

export interface OrderDetailData {
  id: number;
  code: string;
  package_id: string;
  currency: string;
  quantity: number;
  type: string;
  description: string | null;
  esim_type: string;
  validity: number;
  package: string;
  data: string;
  price: number;
  pricing_model: string;
  text: string | null;
  voice: string | null;
  net_price: number;
  created_at: string;
  manual_installation: string;
  qrcode_installation: string;
  installation_guides: {
    en: string;
  };
  sims?: OrderSim[];
  user?: OrderUser;
  status?: OrderStatus;
}

export interface OrderDetailResponse {
  error: boolean;
  data: {
    data: OrderDetailData;
  };
  message: string;
}

@Component({
  standalone: false,
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.scss'
})
export class OrderDetailsComponent implements OnInit {
  order: OrderDetailData | null = null;
  loading = true;
  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private authService: AuthService,
    private _dateService: DateService
  ) {}

  ngOnInit(): void {
    const orderId = this.route.snapshot.paramMap.get('id');
    if (orderId) {
      this.loadOrderDetails(+orderId);
    } else {
      this.error = 'Order ID not found';
      this.loading = false;
    }
  }

  loadOrderDetails(orderId: number): void {
    // The JWT interceptor will automatically add the token header
    this.apiService.getData(`/api/airalo/orders/${orderId}`).subscribe({
      next: (response: OrderDetailResponse) => {
        if (!response.error && response.data && response.data.data) {
          this.order = response.data.data;
        } else {
          this.error = 'Failed to load order details';
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching order details:', err);
        this.error = 'Error loading order details';
        this.loading = false;
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/app/orders']);
  }

  formatDate(dateValue: string): string {
    return this._dateService.getFormattedDateWithAMPM(dateValue);
  }
}